import React, { useContext, Fragment } from "react";
import { Theme, makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Typography,
  Divider,
  FormControlLabel,
  Checkbox,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormGroup,
  RadioGroup,
  Radio,
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import { DesignContext } from "../context/design";
import { LangContext } from "../context/lang";
import MapboxGl from "mapbox-gl";
import { MainContext } from "../context/main";
import { mapserviceList } from "../constant/roles";

const useStyle = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(1),
    height: `calc(100% - ${theme.spacing(2)}px)`,
    overflowY: "auto",
  },
  accordionRoot: { boxShadow: "unset" },
  accordionDetail: { paddingLeft: theme.spacing(4), paddingTop: 0 },
  msGroup: { display: "flex", flexDirection: "column", width: "100%" },
  basemap: { paddingLeft: theme.spacing(2), paddingTop: theme.spacing(1.5) },
}));

const LayersDesign = () => {
  const classes = useStyle();
  const {
    map,
    electrictLayers,
    setelectrictLayers,
    administrativeLayers,
    setadministrativeLayers,
    basemap,
    setbasemap,
  } = useContext(DesignContext);
  const { userInfo } = useContext(MainContext);
  const { lang } = useContext(LangContext);

  const toggleGroup = (event: React.ChangeEvent<HTMLInputElement>) => {
    const mapLayers = map?.getStyle().layers;
    const splitName = event.target.name.split(".");
    const newGroupValue = electrictLayers[splitName[0]][
      splitName[1]
    ].map((group: any) => ({ ...group, check: event.target.checked }));
    newGroupValue.map((group: any) => {
      const layers = mapLayers?.filter(
        (l: any) => l["source-layer"] && l["source-layer"] === group.key
      );
      if (layers && layers.length > 0) {
        layers.map((layer: any) =>
          map?.setLayoutProperty(
            layer.id,
            "visibility",
            group.check ? "visible" : "none"
          )
        );
      }
      return null;
    });

    setelectrictLayers({
      ...electrictLayers,
      [splitName[0]]: {
        ...electrictLayers[splitName[0]],
        [splitName[1]]: newGroupValue,
      },
    });
  };

  const toggleLayer = (event: React.ChangeEvent<HTMLInputElement>) => {
    const mapLayers = map?.getStyle().layers;
    const splitName = event.target.name.split(".");
    let newGroupValue = electrictLayers[splitName[0]][splitName[1]];
    const layerIndex = newGroupValue.findIndex(
      (l: any) => l.key === splitName[2]
    );
    newGroupValue[layerIndex].check = event.target.checked;

    const layers = mapLayers?.filter(
      (l: any) => l["source-layer"] && l["source-layer"] === splitName[2]
    );

    if (layers && layers.length > 0) {
      layers.map((layer: any) =>
        map?.setLayoutProperty(
          layer.id,
          "visibility",
          event.target.checked ? "visible" : "none"
        )
      );
    }

    setelectrictLayers({
      ...electrictLayers,
      [splitName[0]]: {
        ...electrictLayers[splitName[0]],
        [splitName[1]]: newGroupValue,
      },
    });
  };

  const toggleAdministrativeBoundary = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const mapLayers = map?.getStyle().layers;

    const layers = mapLayers?.filter(
      (l: any) => l["source-layer"] && l["source-layer"] === event.target.name
    );

    if (layers && layers.length > 0) {
      layers.map((layer: any) =>
        map?.setLayoutProperty(
          layer.id,
          "visibility",
          event.target.checked ? "visible" : "none"
        )
      );
    }

    setadministrativeLayers(
      administrativeLayers.map((al: any) => {
        if (al.key === event.target.name) {
          return { ...al, check: !al.check };
        } else {
          return al;
        }
      })
    );
  };

  const _changeBasemap = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newBasemap = (event.target as HTMLInputElement).value;

    if (map && basemap !== newBasemap) {
      const mapLayers = map.getStyle().layers;
      const layerLandbase = mapserviceList.find((ml) =>
        ml.roles.find((role) => role === userInfo?.role)
      )?.layerId[0];
      const hideLayers = mapLayers?.filter((layer) => {
        if (basemap === "openmaptiles") {
          return layer.source === basemap || layer.source === layerLandbase;
        } else {
          return layer.source === basemap;
        }
      });
      const showLayers = mapLayers?.filter((layer) => {
        if (newBasemap === "openmaptiles") {
          return layer.source === newBasemap || layer.source === layerLandbase;
        } else {
          return layer.source === newBasemap;
        }
      });
      hideLayers?.map((layer: MapboxGl.Layer) => {
        map.setLayoutProperty(layer.id, "visibility", "none");
        return null;
      });
      showLayers?.map((layer: MapboxGl.Layer) => {
        map.setLayoutProperty(layer.id, "visibility", "visible");
        return null;
      });
      setbasemap(newBasemap);
    }
  };

  return (
    <div className={classes.root}>
      <Grid container>
        {electrictLayers &&
          Object.keys(electrictLayers).map((ou: string) => {
            return (
              <Fragment key={ou}>
                <Grid item xs={12}>
                  <Typography variant="h6">{lang.data[ou]}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
                {Object.keys(electrictLayers[ou]).map((group: string) => (
                  <Grid item xs={12} key={`${ou}-${group}`}>
                    <Accordion classes={{ root: classes.accordionRoot }}>
                      <AccordionSummary
                        expandIcon={<ExpandMore />}
                        aria-label="Expand"
                        aria-controls="additional-actions1-content"
                        id="additional-actions1-header"
                      >
                        <FormControlLabel
                          aria-label="Acknowledge"
                          onClick={(event) => event.stopPropagation()}
                          onFocus={(event) => event.stopPropagation()}
                          control={
                            <Checkbox
                              color="primary"
                              checked={
                                electrictLayers[ou][group].filter(
                                  (g: any) => g.check
                                ).length === electrictLayers[ou][group].length
                              }
                              name={`${ou}.${group}`}
                              onChange={toggleGroup}
                            />
                          }
                          label={lang.data[group]}
                        />
                      </AccordionSummary>
                      <AccordionDetails className={classes.accordionDetail}>
                        {/* <div className={classes.msGroup}> */}
                        <FormGroup>
                          {electrictLayers[ou][group].map(
                            (electrictlayer: {
                              check: boolean;
                              key: string;
                            }) => (
                              <FormControlLabel
                                key={`${ou}-${group}-${electrictlayer.key}`}
                                control={
                                  <Checkbox
                                    checked={electrictlayer.check}
                                    onChange={toggleLayer}
                                    name={`${ou}.${group}.${electrictlayer.key}`}
                                    color="primary"
                                  />
                                }
                                label={
                                  <Typography variant="caption">
                                    {lang.data[electrictlayer.key]}
                                  </Typography>
                                }
                              />
                            )
                          )}
                        </FormGroup>
                        {/* </div> */}
                      </AccordionDetails>
                    </Accordion>
                  </Grid>
                ))}
              </Fragment>
            );
          })}
        <Grid item xs={12}>
          <Typography variant="h6">
            {lang.data.administrativeBoundary}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item xs={12} className={classes.basemap}>
          {administrativeLayers &&
            administrativeLayers.map((al: any) => (
              <div key={al.key}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={al.check}
                      onChange={toggleAdministrativeBoundary}
                      name={al.key}
                      color="primary"
                    />
                  }
                  label={
                    <Typography variant="body1">{lang.data[al.key]}</Typography>
                  }
                />
              </div>
            ))}
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6">{lang.data.basemap}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item xs={12} className={classes.basemap}>
          <RadioGroup
            aria-label={lang.data.basemap}
            value={basemap}
            onChange={_changeBasemap}
          >
            <FormControlLabel
              value="openmaptiles"
              control={<Radio color="primary" />}
              label={lang.data.meaTile}
            />
            <FormControlLabel
              value="nostra"
              control={<Radio color="primary" />}
              label={lang.data.nostra}
            />
            <FormControlLabel
              value="mea-ortho"
              control={<Radio color="primary" />}
              label={lang.data.meaOrtho}
            />
          </RadioGroup>
        </Grid>
      </Grid>
    </div>
  );
};

export default LayersDesign;
